import * as React from 'react';
export var defaultTheme = {
  black: '#000000',
  white: '#ffffff',
  'background-1': '#282929',
  'background-2': '#1E1F1E',
  'background-3': '#151716',
  'background-code': '#222728',
  'background-btn': '#454747',
  'background-btn-disabled': '#242424',
  'background-float': '#191A1A',
  'foreground-1': '#EBEBF0',
  'foreground-2': '#9D9DA3',
  'foreground-2-hover': '#B1B1B5',
  'foreground-2-disabled': '#404142',
  'foreground-3': '#4E4E52',
  'foreground-disabled': '#454747',
  'accent-primary': '#1BB380',
  'accent-primary-hover': '#56C39F',
  'accent-blue': '#5081FF',
  'accent-error': '#CC443D',
  'accent-error-hover': '#CF5853',
  'accent-warn': '#E67A45',
  'accent-success': '#28A745',
  'accent-divider': '#323333',
  'shadow-float': '0px 8px 20px -2px rgba(0, 0, 0, 0.4)',
  'shadow-tabs': '0px 24px 36px -2px rgba(0, 0, 0, 0.24)'
};
export var AppContext = /*#__PURE__*/React.createContext({
  theme: defaultTheme
});
export var AppProvider = AppContext.Provider;
export function useTheme() {
  return React.useContext(AppContext);
}